<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>南侧索夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">索夹</div>
          <!-- <div class="sensor2">进气口</div> -->
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">镇宁</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">胜境关</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1E2, humidityAllowedMax1E2) }}
              </div>
              <div :class="error1E2" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1E2传感器</p>
                <p>
                  <span>{{ humidity1E2 | toFixed }}% {{ temperature1E2 | toFixed }}°C {{ absHumidity1E2 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1E2 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1E6, humidityAllowedMax1E6) }}
              </div>
              <div :class="error1E6" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1E6传感器</p>
                <p>
                  <span>{{ humidity1E6 | toFixed }}% {{ temperature1E6 | toFixed }}°C {{ absHumidity1E6 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1E6 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1W6, humidityAllowedMax1W6) }}
              </div>
              <div :class="error1W6" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1W6传感器</p>
                <p>
                  <span>{{ humidity1W6 | toFixed }}% {{ temperature1W6 | toFixed }}°C {{ absHumidity1W6 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1W6 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1W2, humidityAllowedMax1W2) }}
              </div>
              <div :class="error1W2" class="state-info top-right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1W2传感器</p>
                <p>
                  <span>{{ humidity1W2 | toFixed }}% {{ temperature1W2 | toFixed }}°C {{ absHumidity1W2 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1W2 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3E6, humidityAllowedMax3E6) }}
              </div>
              <div :class="error3E6" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3E6传感器</p>
                <p>
                  <span>{{ humidity3E6 | toFixed }}% {{ temperature3E6 | toFixed }}°C {{ absHumidity3E6 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3E6 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3W6, humidityAllowedMax3W6) }}
              </div>
              <div :class="error3W6" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3W6传感器</p>
                <p>
                  <span>{{ humidity3W6 | toFixed }}% {{ temperature3W6 | toFixed }}°C {{ absHumidity3W6 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3W6 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2E2, humidityAllowedMax2E2) }}
              </div>
              <div :class="error2E2" class="state-info top-left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2E2传感器</p>
                <p>
                  <span>{{ humidity2E2 | toFixed }}% {{ temperature2E2 | toFixed }}°C {{ absHumidity2E2 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2E2 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2E6, humidityAllowedMax2E6) }}
              </div>
              <div :class="error2E6" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2E6传感器</p>
                <p>
                  <span>{{ humidity2E6 | toFixed }}% {{ temperature2E6 | toFixed }}°C {{ absHumidity2E6 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2E6 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2W6, humidityAllowedMax2W6) }}
              </div>
              <div :class="error2W6" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2W6传感器</p>
                <p>
                  <span>{{ humidity2W6 | toFixed }}% {{ temperature2W6 | toFixed }}°C {{ absHumidity2W6 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2W6 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2W2, humidityAllowedMax2W2) }}
              </div>
              <div :class="error2W2" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2W2传感器</p>
                <p>
                  <span>{{ humidity2W2 | toFixed }}% {{ temperature2W2 | toFixed }}°C {{ absHumidity2W2 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2W2 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北侧索夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">索夹</div>
          <!-- <div class="sensor2">进气口</div> -->
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">镇宁</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">胜境关</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1E3, humidityAllowedMax1E3) }}
              </div>
              <div :class="error1E3" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1E3传感器</p>
                <p>
                  <span>{{ humidity1E3 | toFixed }}% {{ temperature1E3 | toFixed }}°C {{ absHumidity1E3 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1E3 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1E7, humidityAllowedMax1E7) }}
              </div>
              <div :class="error1E7" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1E7传感器</p>
                <p>
                  <span>{{ humidity1E7 | toFixed }}% {{ temperature1E7 | toFixed }}°C {{ absHumidity1E7 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1E7 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1W7, humidityAllowedMax1W7) }}
              </div>
              <div :class="error1W7" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1W7传感器</p>
                <p>
                  <span>{{ humidity1W7 | toFixed }}% {{ temperature1W7 | toFixed }}°C {{ absHumidity1W7 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1W7 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError1W3, humidityAllowedMax1W3) }}
              </div>
              <div :class="error1W3" class="state-info top-right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">1W3传感器</p>
                <p>
                  <span>{{ humidity1W3 | toFixed }}% {{ temperature1W3 | toFixed }}°C {{ absHumidity1W3 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure1W3 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3E7, humidityAllowedMax3E7) }}
              </div>
              <div :class="error3E7" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3E7传感器</p>
                <p>
                  <span>{{ humidity3E7 | toFixed }}% {{ temperature3E7 | toFixed }}°C {{ absHumidity3E7 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3E7 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError3W7, humidityAllowedMax3W7) }}
              </div>
              <div :class="error3W7" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p class="bold">3W7传感器</p>
                <p>
                  <span>{{ humidity3W7 | toFixed }}% {{ temperature3W7 | toFixed }}°C {{ absHumidity3W7 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure3W7 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2E3, humidityAllowedMax2E3) }}
              </div>
              <div :class="error2E3" class="state-info top-left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2E3传感器</p>
                <p>
                  <span>{{ humidity2E3 | toFixed }}% {{ temperature2E3 | toFixed }}°C {{ absHumidity2E3 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2E3 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2E7, humidityAllowedMax2E7) }}
              </div>
              <div :class="error2E7" class="state-info right-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2E7传感器</p>
                <p>
                  <span>{{ humidity2E7 | toFixed }}% {{ temperature2E7 | toFixed }}°C {{ absHumidity2E7 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2E7 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2W7, humidityAllowedMax2W7) }}
              </div>
              <div :class="error2W7" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2W7传感器</p>
                <p>
                  <span>{{ humidity2W7 | toFixed }}% {{ temperature2W7 | toFixed }}°C {{ absHumidity2W7 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2W7 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError2W3, humidityAllowedMax2W3) }}
              </div>
              <div :class="error2W3" class="state-info left-pos" @dblclick="hrefToScenario('')">
                <p class="bold">2W3传感器</p>
                <p>
                  <span>{{ humidity2W3 | toFixed }}% {{ temperature2W3 | toFixed }}°C {{ absHumidity2W3 | toFixed }}g/kg</span>
                  <br /><span>{{ pressure2W3 | toFixed }}Pa </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature, pressure, flow, volume
      humidity1E2: "--",
      humidity1E3: "--",
      humidity1E6: "--",
      humidity1E7: "--",
      humidity1W6: "--",
      humidity1W7: "--",
      humidity1W2: "--",
      humidity1W3: "--",
      humidity3E6: "--",
      humidity3E7: "--",
      humidity3W6: "--",
      humidity3W7: "--",
      humidity2E2: "--",
      humidity2E3: "--",
      humidity2E6: "--",
      humidity2E7: "--",
      humidity2W6: "--",
      humidity2W7: "--",
      humidity2W2: "--",
      humidity2W3: "--",

      temperature1E2: "--",
      temperature1E3: "--",
      temperature1E6: "--",
      temperature1E7: "--",
      temperature1W6: "--",
      temperature1W7: "--",
      temperature1W2: "--",
      temperature1W3: "--",
      temperature3E6: "--",
      temperature3E7: "--",
      temperature3W6: "--",
      temperature3W7: "--",
      temperature2E2: "--",
      temperature2E3: "--",
      temperature2E6: "--",
      temperature2E7: "--",
      temperature2W6: "--",
      temperature2W7: "--",
      temperature2W2: "--",
      temperature2W3: "--",

      pressure1E2: "--",
      pressure1E3: "--",
      pressure1E6: "--",
      pressure1E7: "--",
      pressure1W6: "--",
      pressure1W7: "--",
      pressure1W2: "--",
      pressure1W3: "--",
      pressure3E6: "--",
      pressure3E7: "--",
      pressure3W6: "--",
      pressure3W7: "--",
      pressure2E2: "--",
      pressure2E3: "--",
      pressure2E6: "--",
      pressure2E7: "--",
      pressure2W6: "--",
      pressure2W7: "--",
      pressure2W2: "--",
      pressure2W3: "--",

      //abs humidity
      absHumidity1E2: "--",
      absHumidity1E3: "--",
      absHumidity1E6: "--",
      absHumidity1E7: "--",
      absHumidity1W6: "--",
      absHumidity1W7: "--",
      absHumidity1W2: "--",
      absHumidity1W3: "--",
      absHumidity3E6: "--",
      absHumidity3E7: "--",
      absHumidity3W6: "--",
      absHumidity3W7: "--",
      absHumidity2E2: "--",
      absHumidity2E3: "--",
      absHumidity2E6: "--",
      absHumidity2E7: "--",
      absHumidity2W6: "--",
      absHumidity2W7: "--",
      absHumidity2W2: "--",
      absHumidity2W3: "--",

      //running

      //malfunction

      //error
      error1E2: "--",
      error1E3: "--",
      error1E6: "--",
      error1E7: "--",
      error1W6: "--",
      error1W7: "--",
      error1W2: "--",
      error1W3: "--",
      error3E6: "--",
      error3E7: "--",
      error3W6: "--",
      error3W7: "--",
      error2E2: "--",
      error2E3: "--",
      error2E6: "--",
      error2E7: "--",
      error2W6: "--",
      error2W7: "--",
      error2W2: "--",
      error2W3: "--",

      //running class

      //humidity allowed max
      humidityAllowedMax1E2: "--",
      humidityAllowedMax1E3: "--",
      humidityAllowedMax1E6: "--",
      humidityAllowedMax1E7: "--",
      humidityAllowedMax1W6: "--",
      humidityAllowedMax1W7: "--",
      humidityAllowedMax1W2: "--",
      humidityAllowedMax1W3: "--",
      humidityAllowedMax3E6: "--",
      humidityAllowedMax3E7: "--",
      humidityAllowedMax3W6: "--",
      humidityAllowedMax3W7: "--",
      humidityAllowedMax2E2: "--",
      humidityAllowedMax2E3: "--",
      humidityAllowedMax2E6: "--",
      humidityAllowedMax2E7: "--",
      humidityAllowedMax2W6: "--",
      humidityAllowedMax2W7: "--",
      humidityAllowedMax2W2: "--",
      humidityAllowedMax2W3: "--",

      //humidity tooltip error
      humidityTooltipError1E2: "--",
      humidityTooltipError1E3: "--",
      humidityTooltipError1E6: "--",
      humidityTooltipError1E7: "--",
      humidityTooltipError1W6: "--",
      humidityTooltipError1W7: "--",
      humidityTooltipError1W2: "--",
      humidityTooltipError1W3: "--",
      humidityTooltipError3E6: "--",
      humidityTooltipError3E7: "--",
      humidityTooltipError3W6: "--",
      humidityTooltipError3W7: "--",
      humidityTooltipError2E2: "--",
      humidityTooltipError2E3: "--",
      humidityTooltipError2E6: "--",
      humidityTooltipError2E7: "--",
      humidityTooltipError2W6: "--",
      humidityTooltipError2W7: "--",
      humidityTooltipError2W2: "--",
      humidityTooltipError2W3: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidity1E2: "54749eb9-f128-4fbd-b9a2-acdfd30ced63",
        humidity1E3: "fc61050c-7ba9-42ab-86c1-cf0b64f76abe",
        humidity1E6: "b342ca48-6987-4705-a1af-0f6650723d68",
        humidity1E7: "71251b80-d698-4f67-b9a7-7064e0da2b9a",
        humidity1W6: "aadddf1a-b97a-450c-bc47-afa47055edf0",
        humidity1W7: "8ce5f154-25e6-4fc0-be0b-513708330539",
        humidity1W2: "78975a63-bdf7-453a-ba34-0a308f1622b7",
        humidity1W3: "d5fb81f4-98ea-43f1-a3f7-f42359eb8724",
        humidity3E6: "f66eca72-fb8f-450c-a63a-14efa3f51280",
        humidity3E7: "30c16e46-e9ff-4ffd-ade1-3c0dd927cd06",
        humidity3W6: "38588202-b92a-41e1-b684-308cb1328ea0",
        humidity3W7: "925eec53-2d81-42fd-a19b-c60a9b992c9f",
        humidity2E2: "1e097d77-33d2-41ac-befc-4b5c04961e6d",
        humidity2E3: "e2259977-f9ad-43a1-ab3d-3ee65d0c5ab9",
        humidity2E6: "f42408a5-cefe-43d4-9975-3d9f5bf21380",
        humidity2E7: "5d47eb2f-1337-4c01-a5c8-45bdca26e85d",
        humidity2W6: "3b2f9e44-1601-4726-aaf3-9aa974f626e6",
        humidity2W7: "71af97a4-2e07-4140-94e8-3c0d02b509a3",
        humidity2W2: "aa9ce7d7-817b-45c9-b379-30c47dfbddb9",
        humidity2W3: "22229fd7-3afa-455f-9cea-3d5473f783dd",

        temperature1E2: "226676a9-f188-4818-9935-63feb60e0057",
        temperature1E3: "96cb2b35-e8a2-41af-843d-6e7851216224",
        temperature1E6: "34d62682-960f-4816-81b5-1e0dd52819f6",
        temperature1E7: "ccdc2195-41a9-4422-87cb-236d47dc8518",
        temperature1W6: "796e9130-4982-4fed-84d1-e0702267b48f",
        temperature1W7: "49dad8f0-883f-4ecb-89cb-8a7ee218a641",
        temperature1W2: "e7258b79-e4b2-4c00-a9d9-6bf3fad9e86b",
        temperature1W3: "dc41eefe-5035-422c-954a-6a3639d05daa",
        temperature3E6: "80bb6ae5-8e4f-4127-8824-1ee51fdd1549",
        temperature3E7: "097c3e78-c327-4d98-ae37-d3ff5e6307d0",
        temperature3W6: "f92b025d-dbee-4fd7-bdcd-e79256a05e66",
        temperature3W7: "28669f3e-1f68-4b98-9655-2470dd07ed39",
        temperature2E2: "5e8cb5e3-6a1d-4147-9893-0ffa072a178d",
        temperature2E3: "2a016d8f-75a1-41a0-a00b-317daafeb0b6",
        temperature2E6: "4bb22d1e-8dcf-4c6e-9c78-ac23efbfb91b",
        temperature2E7: "c6c5c40f-38fb-4994-bc4b-fda9ac7b1505",
        temperature2W6: "ffd40f76-57c4-4cb6-a088-27db9348f6d5",
        temperature2W7: "8e418717-2bdd-4793-b16c-743ca8e8ef4a",
        temperature2W2: "c0d2446e-f669-45a8-a9b8-6509ab0e6b4d",
        temperature2W3: "9aadd5a2-b64a-4cd1-8896-bb30c5804f04",

        pressure1E2: "423573b8-c4f1-4a67-8fd2-838325cfb92a",
        pressure1E3: "1a4953ac-8daa-453c-94ee-60b19ca48d9f",
        pressure1E6: "0d120076-4189-45d3-81bb-54e6216789ac",
        pressure1E7: "aeed0458-1f67-436c-b13f-2d171b55e24a",
        pressure1W6: "2c751544-6abe-4deb-b079-3984517561f5",
        pressure1W7: "5cb4ab62-64d2-4f92-8e4f-0e01e29c4a81",
        pressure1W2: "deaf5456-5bd7-48b8-8c4b-3d3b59b159a7",
        pressure1W3: "3eb845c1-dffb-4003-b0a9-4a6fe774cfa6",
        pressure3E6: "027bd482-d49f-4503-8cdd-64492fbe1743",
        pressure3E7: "b46502af-e89e-48bf-a125-69e48d8fd8bc",
        pressure3W6: "26c7ceb2-8178-460f-bfad-1a345d327e2f",
        pressure3W7: "16ed410d-9bfc-4404-b2c7-66c40e03a880",
        pressure2E2: "c6cdfb13-64fb-4c73-bcc1-6eff44f6f0c6",
        pressure2E3: "9bc5317f-ffe8-48a8-9402-2e81243eb23f",
        pressure2E6: "29c325ca-b4f8-4233-a12a-26bce4d668fd",
        pressure2E7: "ec235276-7ee2-42b6-a384-15956a02cc6b",
        pressure2W6: "685ef733-9a88-4290-b1ee-ca7d9b9b87df",
        pressure2W7: "376eaade-1a52-4d97-b4d7-a399a0e812e4",
        pressure2W2: "a22a1cd9-95ac-4e22-af12-038835c4630c",
        pressure2W3: "7feae805-e421-45e8-8e5d-f025ad8728d4",

        //abs humidity
        absHumidity1E2: "d6ff567b-357a-4d74-b970-532b0e25dd72",
        absHumidity1E3: "ffd43523-c9c3-4b68-9bb4-54a22e497c0d",
        absHumidity1E6: "6e66a49e-8604-421f-b4d7-bf45a617ed33",
        absHumidity1E7: "8bcc4d72-e85d-44a2-a39d-897569d620aa",
        absHumidity1W6: "bfaefea7-b986-46a6-82bf-fe815af2d48a",
        absHumidity1W7: "9a95231e-6750-42ee-8be6-bafff639d895",
        absHumidity1W2: "57614928-22e9-45ab-aa6e-976d064d7345",
        absHumidity1W3: "e2a9ee6e-5cb4-49e5-a09e-4437ddfe77df",
        absHumidity3E6: "5e70f65c-99e6-40a3-b600-f0300a084805",
        absHumidity3E7: "c35ffb74-6460-425f-9902-d9083493447e",
        absHumidity3W6: "e43b5c5a-5cfb-4d2b-a018-5bc8c70d3702",
        absHumidity3W7: "66dcfefb-6888-4c98-8fd0-0a2cb0c4c273",
        absHumidity2E2: "6a12e337-0db3-450e-bba1-f3eaffe7f9aa",
        absHumidity2E3: "8d12879c-e677-4d8f-b71c-1caf4ab49eca",
        absHumidity2E6: "fb2905c0-88d7-414c-a34c-29fe653cf9dc",
        absHumidity2E7: "5b795085-405e-4c53-800f-371e95927510",
        absHumidity2W6: "f24f3915-bbc4-4fb8-99f6-78e39371a329",
        absHumidity2W7: "d5186736-7652-494f-86ef-e86330e22278",
        absHumidity2W2: "ffa0300e-7021-42ee-a352-1b89f2a128af",
        absHumidity2W3: "2abeea65-c2cc-4b1b-a60c-711ed6e0d92c",

        //running

        //malfunction
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMax1E2: "54749eb9-f128-4fbd-b9a2-acdfd30ced63",
        humidityAllowedMax1E3: "fc61050c-7ba9-42ab-86c1-cf0b64f76abe",
        humidityAllowedMax1E6: "b342ca48-6987-4705-a1af-0f6650723d68",
        humidityAllowedMax1E7: "71251b80-d698-4f67-b9a7-7064e0da2b9a",
        humidityAllowedMax1W6: "aadddf1a-b97a-450c-bc47-afa47055edf0",
        humidityAllowedMax1W7: "8ce5f154-25e6-4fc0-be0b-513708330539",
        humidityAllowedMax1W2: "78975a63-bdf7-453a-ba34-0a308f1622b7",
        humidityAllowedMax1W3: "d5fb81f4-98ea-43f1-a3f7-f42359eb8724",
        humidityAllowedMax3E6: "f66eca72-fb8f-450c-a63a-14efa3f51280",
        humidityAllowedMax3E7: "30c16e46-e9ff-4ffd-ade1-3c0dd927cd06",
        humidityAllowedMax3W6: "38588202-b92a-41e1-b684-308cb1328ea0",
        humidityAllowedMax3W7: "925eec53-2d81-42fd-a19b-c60a9b992c9f",
        humidityAllowedMax2E2: "1e097d77-33d2-41ac-befc-4b5c04961e6d",
        humidityAllowedMax2E3: "e2259977-f9ad-43a1-ab3d-3ee65d0c5ab9",
        humidityAllowedMax2E6: "f42408a5-cefe-43d4-9975-3d9f5bf21380",
        humidityAllowedMax2E7: "5d47eb2f-1337-4c01-a5c8-45bdca26e85d",
        humidityAllowedMax2W6: "3b2f9e44-1601-4726-aaf3-9aa974f626e6",
        humidityAllowedMax2W7: "71af97a4-2e07-4140-94e8-3c0d02b509a3",
        humidityAllowedMax2W2: "aa9ce7d7-817b-45c9-b379-30c47dfbddb9",
        humidityAllowedMax2W3: "22229fd7-3afa-455f-9cea-3d5473f783dd",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidity1E2: "error1E2",
        humidity1E3: "error1E3",
        humidity1E6: "error1E6",
        humidity1E7: "error1E7",
        humidity1W6: "error1W6",
        humidity1W7: "error1W7",
        humidity1W2: "error1W2",
        humidity1W3: "error1W3",
        humidity3E6: "error3E6",
        humidity3E7: "error3E7",
        humidity3W6: "error3W6",
        humidity3W7: "error3W7",
        humidity2E2: "error2E2",
        humidity2E3: "error2E3",
        humidity2E6: "error2E6",
        humidity2E7: "error2E7",
        humidity2W6: "error2W6",
        humidity2W7: "error2W7",
        humidity2W2: "error2W2",
        humidity2W3: "error2W3",

        temperaturer1E2: "error1E2",
        temperaturer1E3: "error1E3",
        temperaturer1E6: "error1E6",
        temperaturer1E7: "error1E7",
        temperaturer1W6: "error1W6",
        temperaturer1W7: "error1W7",
        temperaturer1W2: "error1W2",
        temperaturer1W3: "error1W3",
        temperaturer3E6: "error3E6",
        temperaturer3E7: "error3E7",
        temperaturer3W6: "error3W6",
        temperaturer3W7: "error3W7",
        temperaturer2E2: "error2E2",
        temperaturer2E3: "error2E3",
        temperaturer2E6: "error2E6",
        temperaturer2E7: "error2E7",
        temperaturer2W6: "error2W6",
        temperaturer2W7: "error2W7",
        temperaturer2W2: "error2W2",
        temperaturer2W3: "error2W3",

        pressure1E2: "error1E2",
        pressure1E3: "error1E3",
        pressure1E6: "error1E6",
        pressure1E7: "error1E7",
        pressure1W6: "error1W6",
        pressure1W7: "error1W7",
        pressure1W2: "error1W2",
        pressure1W3: "error1W3",
        pressure3E6: "error3E6",
        pressure3E7: "error3E7",
        pressure3W6: "error3W6",
        pressure3W7: "error3W7",
        pressure2E2: "error2E2",
        pressure2E3: "error2E3",
        pressure2E6: "error2E6",
        pressure2E7: "error2E7",
        pressure2W6: "error2W6",
        pressure2W7: "error2W7",
        pressure2W2: "error2W2",
        pressure2W3: "error2W3",

        //abs humidity
        absHumidity1E2: "error1E2",
        absHumidity1E3: "error1E3",
        absHumidity1E6: "error1E6",
        absHumidity1E7: "error1E7",
        absHumidity1W6: "error1W6",
        absHumidity1W7: "error1W7",
        absHumidity1W2: "error1W2",
        absHumidity1W3: "error1W3",
        absHumidity3E6: "error3E6",
        absHumidity3E7: "error3E7",
        absHumidity3W6: "error3W6",
        absHumidity3W7: "error3W7",
        absHumidity2E2: "error2E2",
        absHumidity2E3: "error2E3",
        absHumidity2E6: "error2E6",
        absHumidity2E7: "error2E7",
        absHumidity2W6: "error2W6",
        absHumidity2W7: "error2W7",
        absHumidity2W2: "error2W2",
        absHumidity2W3: "error2W3",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {},

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidity1E2: "humidityTooltipError1E2",
        humidity1E3: "humidityTooltipError1E3",
        humidity1E6: "humidityTooltipError1E6",
        humidity1E7: "humidityTooltipError1E7",
        humidity1W6: "humidityTooltipError1W6",
        humidity1W7: "humidityTooltipError1W7",
        humidity1W2: "humidityTooltipError1W2",
        humidity1W3: "humidityTooltipError1W3",
        humidity3E6: "humidityTooltipError3E6",
        humidity3E7: "humidityTooltipError3E7",
        humidity3W6: "humidityTooltipError3W6",
        humidity3W7: "humidityTooltipError3W7",
        humidity2E2: "humidityTooltipError2E2",
        humidity2E3: "humidityTooltipError2E3",
        humidity2E6: "humidityTooltipError2E6",
        humidity2E7: "humidityTooltipError2E7",
        humidity2W6: "humidityTooltipError2W6",
        humidity2W7: "humidityTooltipError2W7",
        humidity2W2: "humidityTooltipError2W2",
        humidity2W3: "humidityTooltipError2W3",
      },

      //running -> running class
      dataNameRunningClassNameDict: {},

      //station id list
      stationIdList: ["a24b3cf2-29da-4696-ac07-8f3faf4ed543"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }

  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}

@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }

  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1350px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .sensor1:after {
          background: #c7798b;
        }

        .sensor2:after {
          background: #3376c7;
        }
      }

      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .default:after {
          background: #ffff00;
        }

        .running:after {
          background: #67dd34;
        }

        .stopped:after {
          background: #a0a0a0;
        }
      }

      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }

        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;

        i {
          font-size: 30px;
        }

        .dir-text {
          font-size: 20px;
        }
      }

      .left-dir {
        left: 185px;
      }

      .right-dir {
        flex-direction: row-reverse;
        right: 185px;
      }

      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/balinghe/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);

            &:before {
              background-color: #ed6a5a;
            }

            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .bold {
              font-weight: 800;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }

              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            & > p {
              margin: 0;
              white-space: nowrap;

              &:first-child {
                font-size: 13px;
              }
            }

            .bold {
              font-weight: 800;
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 46%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &.top-left-pos:before {
              left: 26.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &.top-right-pos:before {
              left: 74.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.sensor1 {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }

          &.sensor2 {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sensor-left-1 {
          top: 165px;
          left: 105px;

          &::before {
            bottom: 16px;
            left: -15px;
            width: 26px;
            transform: rotate(45deg);
          }

          &::after {
            bottom: 25px;
            left: -26px;
          }

          .state-info {
            right: 40px;
            top: -10px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-left-2 {
          top: 126px;
          left: 180px;

          &::before {
            bottom: 30px;
            left: -31px;
            width: 60px;
            transform: rotate(70deg);
          }

          &::after {
            bottom: 58px;
            left: -26px;
          }

          .state-info {
            right: 40px;
            top: -43px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-1 {
          top: 113px;
          left: 280px;

          &::before {
            bottom: 50px;
            left: -33px;
            width: 90px;
            transform: rotate(95deg);
          }

          &::after {
            bottom: 94px;
            left: 15px;
          }

          .state-info {
            right: -161px;
            top: -79px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-2 {
          top: 137px;
          left: 365px;

          &::before {
            bottom: -24px;
            left: -22px;
            width: 60px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -68px;
            left: -14px;
            width: 0px;
          }

          .state-info {
            right: -27px;
            top: 90px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-left-3 {
          top: 154px;
          left: 458px;

          &::before {
            bottom: 20px;
            left: -5px;
            width: 25px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -62px;
            top: -45px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-3 {
          top: 152px;
          left: 732px;

          &::before {
            bottom: 20px;
            left: -5px;
            width: 25px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -62px;
            top: -45px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-2 {
          top: 135px;
          left: 825px;

          &::before {
            bottom: -24px;
            left: -22px;
            width: 60px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -68px;
            left: -14px;
            width: 0px;
          }

          .state-info {
            right: -97px;
            top: 90px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-middle-right-1 {
          top: 110px;
          left: 910px;

          &::before {
            bottom: 48px;
            left: -41px;
            width: 90px;
            transform: rotate(85deg);
          }

          &::after {
            bottom: 93px;
            left: -14px;
          }

          .state-info {
            right: 30px;
            top: -78px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-right-2 {
          top: 113px;
          left: 1000px;

          &::before {
            bottom: 30px;
            left: -13px;
            width: 60px;
            transform: rotate(110deg);
          }

          &::after {
            bottom: 58px;
            left: 26px;
          }

          .state-info {
            right: -170px;
            top: -43px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }

        .sensor-right-1 {
          top: 152px;
          left: 1068px;

          &::before {
            bottom: 16px;
            left: 3px;
            width: 26px;
            transform: rotate(135deg);
          }

          &::after {
            bottom: 25px;
            left: 24px;
          }

          .state-info {
            right: -167px;
            top: -10px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 150px;
          }
        }
      }
    }
  }
}
</style>
